function pathToArray( path ) {
  if ( path == null || path.length === 0 ) {
    return [];
  }
  const arr = path.split( '/' )
  // optimization
  if ( arr.length === 1 ) {
    arr[0] = arr[0].trim()
    if ( arr[0].length === 0 ) {
      return []
    }
    return arr
  }
  for ( let n = arr.length - 1; n >= 0; n-- ) {
    arr[n] = arr[n].trim()
    if ( arr[n].length === 0 ) {
      arr.splice( n, 1 );
    }
  }
  return arr;
}

function Path( pathname ) {
  let pathArr;
  let path = pathname;

  if ( typeof path === 'string' ) {
    pathArr = pathToArray( path );
  } else if ( Array.isArray( path ) ) {
    pathArr = [ ...path ];
  } else {
    pathArr = [];
  }
  path = pathArr.join( '/' );

  return {
    
    path() { return path },
    pathArray() { return [].concat( pathArr ); },
    last() {
      return pathArr.length === 0 ? null : pathArr[pathArr.length - 1];
    }, 
    changeLast( name ) {
      const len = pathArr.length;
      if ( len > 0 ) {
        pathArr[len - 1] = name;
        path = pathArr.join( '/' );
      } else {
        path = name;
        pathArr = [ name ];
      }
    },

    add( nextNode, inPlace ) {
      if ( inPlace ) {
        path = `${path}/${nextNode}`;
        pathArr.push( nextNode );
        return this;
      }
      return Path( [ ...pathArr, nextNode ] );
      
    },

    removeLast( inPlace ) {
      if ( inPlace ) {
        pathArr.pop();
        path = pathArr.join( '/' );
        return this;
      } 
      const arr = [].concat( pathArr );
      arr.pop();
      return Path( arr );
      
    },

    /*
     * Returns the value at the path in the object, or dVal if it doesnt
     * exist.
     **/
    get( obj, dVal ) {
      let p = obj;
      let n = 0;

      // speed optimization
      if ( pathArr.length === 1 ) {
        p = p ? p[pathArr[0]] : undefined
        return p !== undefined ? p : dVal;
      } 

      while ( p && n < pathArr.length ) {
        p = p[pathArr[n]];
        n++;
      }
      return n === pathArr.length && p !== undefined ? p : dVal;
    },

    /**
     * Sets the value on the object at the path. This will
     * create intermediate objects as necessary.
     **/ 
    set( obj, value, opts ) {
      if ( obj == null || isNumberOrString( obj ) ) {
        return false 
      }
      let p = obj;
      let n = 0;
      const len = pathArr.length - 1;
      while ( p && n < len ) {
        const key = pathArr[n];

        if ( p[key] == null ) {
          p[key] = {};
          p = p[key];
        } else if ( typeof p[key] === 'object' ) {
          p = p[key];
        } else if ( opts?.replace ) {
          // overwrite whatever's there
          p[key] = {}
          p = p[key]
        } else {
          // not an object. illegal path
          return false;
        }
        n++;
      }
      
      p[pathArr[len]] = value;
    
      return true;
    },

    /**
     * Deletes the value on the object at the path. This will
     * not create intermediate.
     * @param {object} obj the object to remove the path from
     * @return {boolean} true if a delete occurred
     **/ 
    delete( obj ) {
      if ( obj == null || isNumberOrString( obj ) ) {
        return false 
      }
      let p = obj;
      let n = 0;
      const len = pathArr.length - 1;
      while ( p && n < len ) {
        const key = pathArr[n];

        if ( p[key] == null ) {
          return false;
        }
        if ( typeof p[key] === 'object' ) {
          p = p[key];
        } else {
          // not an object. illegal path
          return false;
        }
        n++;
      }
      
      if ( Object.prototype.hasOwnProperty.call( p, pathArr[len] ) ) {
        delete p[pathArr[len]]
        return true
      }  
      return false;
    },

    /**
     * Creates a shallow copy of the object and all the paths
     * References to objects that are not in the path will reference
     * the same object. If the value is not undefined, it will be
     * set on the copied object.
     **/
    copy( obj, value ) {
      const c = doCopy( obj, pathArr )
      if ( value !== undefined ) {
        this.set( c, value )
      }
      return c
    }
  }
}

function get( path, obj, dVal ) {
  const p = Path( path );
  return p.get( obj, dVal );
}

function set( path, obj, value, opts ) {
  const p = Path( path );
  return p.set( obj, value, opts );
}

function remove( path, obj ) {
  const p = Path( path );
  return p.delete( obj );
}

function copy( path, obj, value ) {
  const p = Path( path );
  return p.copy( obj, value )
}

function setIf( dst, src, path, ifTypeIs, opts ) {
  const p = Path( path );
  const v = p.get( src );
  if ( v && typeof v === ifTypeIs ) { // eslint-disable-line valid-typeof
    p.set( dst, v, opts );
  }
}

function isNumberOrString( v ) {
  return typeof v === 'string' || typeof v === 'number'
}

function doCopy( obj, arr, index = 0 ) {
  let c = null
  if ( obj == null ) {
    return null
  }
  if ( isNumberOrString( obj ) ) {
    return obj
  }
  if ( Array.isArray( obj ) ) {
    c = [].concat( obj )
  } else if ( typeof obj === 'object' ) {
    c = { ...obj }
  }
  if ( index < arr.length ) {
    const key = arr[index]
    if ( c[key] == null ) {
      return c
    }
    c[key] = doCopy( c[key], arr, index + 1 )
  }
  return c
}

Path.valueAtPath = get;
Path.get = get
Path.set = set
Path.delete = remove
Path.copy = copy
Path.setIf = setIf;

module.exports = Path
